import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  GET_ATENCION_SIN_TURNO,
  GET_ATENCION_SIN_TURNO_FAIL,
  GET_ATENCION_SIN_TURNO_SUCCESS,
  GET_CENTROS,
  GET_CENTROS_FAIL,
  GET_CENTROS_SUCCESS,
} from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

// ============================================================================
// CÓDIGO HUÉRFANO - NO TIENE CAMINO DE NAVEGACIÓN ACTIVO
// Ver: docs/codigo-huerfano-autocheckin.md
// La página AtencioSinTurno que usa este endpoint es inaccesible
// ============================================================================
// export const wsGetAtencionSinTurno =
//   (idPaciente, idCentro, nextStep) => (dispatch) => {
//     dispatch({ type: GET_ATENCION_SIN_TURNO });
//     axiosAutoCheck().then((respuesta) => {
//       respuesta
//         .get(`/demanda/${idCentro}/${idPaciente}`)
//         .then((resp) => {
//           dispatch({
//             type: GET_ATENCION_SIN_TURNO_SUCCESS,
//             payload: resp.data,
//           });
//           if (nextStep) nextStep(true, resp.data);
//         })
//         .catch((err) => {
//           dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err.data });
//           if (nextStep) nextStep(false, err.response.data);
//         });
//     });
//   };

export const wsGetAllDemanda =
  (idCentro, idPacFamiliar, idOrden, nextStep) => (dispatch) => {
    dispatch({ type: GET_ATENCION_SIN_TURNO });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`his/demanda/all/${idCentro}/${idOrden}`)
        .then((resp) => {
          dispatch({
            type: GET_ATENCION_SIN_TURNO_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

export const wsGetAllCentrosDemanda = (nextStep) => (dispatch) => {
  dispatch({ type: GET_ATENCION_SIN_TURNO });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`his/demanda/allCentros`)
      .then((resp) => {
        dispatch({
          type: GET_ATENCION_SIN_TURNO_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_ATENCION_SIN_TURNO_FAIL, payload: err?.response?.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsGetVerificarOsAtencionSinTurno =
  (idPaciente, medico, especialidad, nextStep) => (dispatch) => {
    axiosLogin().then((respuesta) => {
      respuesta
        // CONSULTA PENDIENTE: ¿Tiene sentido mantener 2 false fijos?
        // Ver: docs/consultas-equipo-autocheckin.md (punto 1)
        .get(
          `his/demanda/verificarOsQr/${medico}/${especialidad}/${false}/${false}`,
        )
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

// ============================================================================
// NOTA: Ambas funciones llaman al MISMO endpoint (his/demanda/qr)
// - wsPostTomarAtencionSinTurno: usado en AgendasDisponibles.js (con orden digital)
// - wsPostTomarDemanda: usado en DemandaEspontanea.js (demanda espontánea)
// El parámetro idPacFamiliar ya no se usa en la URL (siempre se pasa -1)
// Ver: docs/endpoint-tomarDemanda-autocheckin.md
// ============================================================================

export const wsPostTomarAtencionSinTurno =
  (dto, nextStep, idPacFamiliar) => () => {
    axiosLogin().then((respuesta) => {
      respuesta
        .post(`his/demanda/qr`, dto)
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(false, err);
        });
    });
  };

export const wsPostTomarDemanda = (dto, nextStep, idPacFamiliar) => () => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`his/demanda/qr`, dto)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err);
      });
  });
};

export const wsGetCentros = (nextStep) => (dispatch) => {
  dispatch({ type: GET_CENTROS });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/shared/centros`)
      .then((resp) => {
        dispatch({ type: GET_CENTROS_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_CENTROS_FAIL, payload: err });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const setCentroId = (id) => (dispatch) => {
  dispatch({ type: GET_CENTROS_SUCCESS, payload: id });
};
